import React from "react";

import { Row } from "react-bootstrap";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import MasterDetailSection from "./MasterDetailSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/transporte",
    label: "Transporte",
  },
  {
    path: "/planeacion",
    label: "Planeación de transporte",
    isActive: true,
  },
];

function PlaneacionTransporte() {
  return (
    <Page
      title="Planeación de transporte"
      description="Visualiza y editar hojas de transportes."
      breadCrumbs={breadCrumbs}
    >
      <Row className="justify-content-center">
        <div className="col-xs-11 col-md-6 col-lg-4">
          <MasterDetailSection />
        </div>
      </Row>
    </Page>
  );
}

export default PlaneacionTransporte;
